import Data from '../Api/Data'
import PrimaryKey from '../Api/PrimaryKey'
import { Type } from 'class-transformer'
import TContactPersonDM from './TContactPersonDM'

export default class TPartnerContactPersonDM extends Data {
	public static className = 'TPartnerContactPersonDM'
	public static primaryKey = 'RID'
	public static systemFields = [
		'RecordID',
	]

	public getPrimaryKey(): PrimaryKey {
		return this.RID!
	}

	AuxiliaryRID?: number
	SlaveRID?: number
	LinkTypeId?: number
	RID?: number
	RecordMod?: number
	RecordES?: number
	RecordID?: number
	RecordState?: number
	SelectionImgCalc?: string
	LegislationContextCalc?: number
	CurrentDateCalc?: Date
	CurrentTimeCalc?: Date
	DefaultValueImgCalc?: string
	@Type(() => TContactPersonDM)
	MasterRID?: TContactPersonDM
}